import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=66858e86&scoped=true"
import script from "./StandardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=66858e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66858e86",
  null
  
)

export default component.exports